import { supabase } from './supabase';

// Check if the user has enough credits
export const checkUserCredits = async (userId) => {
  try {
    const { data, error } = await supabase
      .from('user_credits')
      .select('credits')
      .eq('user_id', userId)
      .single();
      
    if (error) throw error;
    
    return { 
      hasEnoughCredits: data.credits > 0,
      credits: data.credits 
    };
  } catch (error) {
    console.error('Error checking user credits:', error);
    return { hasEnoughCredits: false, credits: 0 };
  }
};

// Decrease credits after document generation
export const decreaseUserCredits = async (userId, refreshCreditsCallback) => {
  try {
    // First get the current credit amount
    const { data: currentData, error: fetchError } = await supabase
      .from('user_credits')
      .select('credits')
      .eq('user_id', userId)
      .single();
      
    if (fetchError) throw fetchError;
    
    // Then update it by subtracting 1
    const newCredits = Math.max(0, currentData.credits - 1);
    
    const { data, error } = await supabase
      .from('user_credits')
      .update({ credits: newCredits })
      .eq('user_id', userId)
      .select('credits')
      .single();
    
    if (error) throw error;
    
    // Call the refreshCredits callback if provided
    if (typeof refreshCreditsCallback === 'function') {
      refreshCreditsCallback();
    }
    
    return { 
      success: true,
      remainingCredits: data.credits 
    };
  } catch (error) {
    console.error('Error decreasing user credits:', error);
    return { success: false, remainingCredits: null };
  }
};